import Cookie from 'js-cookie';

import { USER_REQUEST_PATH_COOKIE } from 'utils/constants';

export const notAuthenticatedConfig = {
  title: 'Not Authenticated',
  content: 'Your session has expired. Please click OK to log in again',
  onConfirmation: () => {
    // Redirect to the current url after user login
    Cookie.set(USER_REQUEST_PATH_COOKIE, window.location.href, {
      domain: '.calix.com',
    });
    window.location.replace(process.env.REACT_APP_CALIX_PORTAL_LOGIN_URL);
  },
};

export const emptyAccessConfig = {
  title: 'Insufficient Privileges',
  content:
    'You have not been granted access to the My Calix Store. We will notify your Customer Operations Representative, and he/she will let you know as soon as your access is granted.',
  onConfirmation: () => window.location.replace(process.env.REACT_APP_CALIX_PORTAL_URL),
};

export const noAccessConfig = {
  title: 'Insufficient Privileges',
  content:
    'You have not been granted access to this portion of the My Calix Store. Please contact your Customer Operations Representative to request access.',
  onConfirmation: () => window.location.replace(process.env.REACT_APP_CALIX_PORTAL_URL),
};
